import { z } from 'zod';
export const TransferProjectsRequestSchema = z
    .object({
    fromOrganizationId: z.string().min(1),
    toOrganizationId: z.string().min(1),
})
    .strict();
export const TransferResultResponseSchema = z
    .object({
    projectsTransferred: z.number().multipleOf(1).nonnegative(),
})
    .strict();
export const BatchProjectsRequestSchema = z
    .object({
    ids: z.array(z.string()),
})
    .strict();
export const CopyDemoProjectRequestSchema = z
    .object({
    targetOrganizationId: z.string().min(1),
})
    .strict();
export const SuccessResponseSchema = z
    .object({
    success: z.boolean(),
})
    .strict();
//# sourceMappingURL=Mutations.js.map